import "../../styles/HomePage/Home.css";
import { HOME_VIDEO_FOR_WOMEN } from "../../constants";
import { useSelector } from "react-redux";
import { selectIsSoundOn } from "../../state/slices";
import useDeviceType from "../../hooks/useDeviceType";

function Home() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "720px",
        width: "100vw",
        overflow: "hidden",
        margin: "0px 0px 0px 0px",
      }}
    >
      <BackgroundVideo />
      <VideoOverlay />
    </div>
  );
}

function BackgroundVideo() {
  const isSoundOn = useSelector(selectIsSoundOn);
  return (
    <video
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
      playsinline="playsinline"
      autoplay="autoplay"
      loop="loop"
      muted={!isSoundOn}
      preload="metadata"
    //   poster={HOME_VIDEO_THUMB}
    >
      <source src={HOME_VIDEO_FOR_WOMEN} type="video/mp4" />
      {/* <img src={HOME_VIDEO_THUMB} /> */}
    </video>
  );
}

function VideoOverlay() {
  const { reValue2 } = useDeviceType();
  return (
    <div
      style={{
        backgroundColor: "rgba(4, 1, 1, 0.5)",
        position: "absolute",
        left: "0",
        color: "white",
        height: "720px",
        width: "100vw",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "end",
        margin: "0px 0px 0px 0px",
        padding: reValue2({
          desktop: "0px 0px 80px 0px",
          tablet: "0px 0px 80px 0px",
          mobile: "0px 0px 25px 0px",
        }),
      }}
    >
      <VideoOverlayInnerContent />
    </div>
  );
}

function VideoOverlayInnerContent() {
  const { reValue2 } = useDeviceType();
  return (
    <div
      style={{
        width: reValue2({
          desktop: "90%",
          tablet: "80%",
          mobile: "91%",
        }),
        display: "flex",
        flexDirection: "column",
        bottom: "0",
        left: "0",
      }}
    >
      <VideoHeader1 />
    </div>
  );
}

function VideoHeader1() {
  const { reValue2 } = useDeviceType();
  return (
    <span
      style={{
        color: "white",
        fontSize: reValue2({
          desktop: "73px",
          tablet: "48px",
          mobile: "33px",
        }),
        fontWeight: "bold",
      }}
    >
      SMP for Women
    </span>
  );
}

export default Home;
